import { crud } from '@think-internet/zeus-frontend-package'

const props = {
  ...crud.Features,

  // admin features
  CUSTOMER: 'CUSTOMER',
  PROJECT: 'PROJECT',
  SURVEY_CONTEXT: 'SURVEY_CONTEXT',
  SURVEY: 'SURVEY',
  SURVEY_ANSWER: 'SURVEY_ANSWER',
  SURVEY_ANALYSIS: 'SURVEY_ANALYSIS',
  SURVEY_ANALYSIS_CONCEPT: 'SURVEY_ANALYSIS_CONCEPT',
  MEMBER: 'MEMBER',
  SURVEY_ANALYSIS_CONCEPT_CONFIGURATION: 'SURVEY_ANALYSIS_CONCEPT_CONFIGURATION',
  SURVEY_ANALYSIS_CONCEPT_DATA_CLUSTER: 'SURVEY_ANALYSIS_CONCEPT_DATA_CLUSTER',
  ENABLE_SCREENSHOT_MODE: 'ENABLE_SCREENSHOT_MODE',
  // admin naw features
  NAW_SURVEY: 'NAW_SURVEY',

  // admin controlling features
  CONTROLLING_COMPANY: 'CONTROLLING_COMPANY',
  CONTROLLING_KOSTENSTELLE: 'CONTROLLING_KOSTENSTELLE',
  CONTROLLING_ARBEITSPAKET: 'CONTROLLING_ARBEITSPAKET',
  CONTROLLING_OFFER: 'CONTROLLING_OFFER',
  CONTROLLING_OFFER_ENTRY: 'CONTROLLING_OFFER_ENTRY',
  CONTROLLING_YEAR_REPORT: 'CONTROLLING_YEAR_REPORT',
}

export default props
